import { Context } from '@vue-storefront/core';

export default (context: Context): string => {
  const appIdentifier = context.$shopify.config.app.$config.appIdentifier;
  const token = context.$shopify.config.app.$cookies.get(`${appIdentifier}_token`);

  return token;
};
